import _slicedToArray from "D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var _excluded = ["value", "formatter", "editing", "editFormat", "displayFormat", "localizer", "parse", "onChange", "onBlur", "disabled", "readOnly"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React, { useMemo, useRef, useState } from 'react';
import { isNullOrInvalid } from './dates';
import Input from './Input';
var DatePickerInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var value = _ref.value,
    formatter = _ref.formatter,
    editing = _ref.editing,
    editFormat = _ref.editFormat,
    displayFormat = _ref.displayFormat,
    localizer = _ref.localizer,
    parse = _ref.parse,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var needsFlush = useRef(false);
  var nextTextValue = useMemo(function () {
    return value instanceof Date && isValid(value) ? localizer.formatDate(value, formatter, editing ? editFormat : displayFormat) : '';
  }, [value, formatter, localizer, displayFormat, editing, editFormat]);
  var _useState = useState(nextTextValue),
    _useState2 = _slicedToArray(_useState, 2),
    prevValue = _useState2[0],
    setPrevValue = _useState2[1];
  var _useState3 = useState(nextTextValue),
    _useState4 = _slicedToArray(_useState3, 2),
    textValue = _useState4[0],
    setTextValue = _useState4[1];
  if (prevValue !== nextTextValue) {
    setPrevValue(nextTextValue);
    setTextValue(nextTextValue);
  }
  var handleBlur = function handleBlur(event) {
    if (onBlur) onBlur(event);
    if (needsFlush.current) {
      var date = parse(event.target.value);
      var dateIsInvalid = event.target.value != '' && isNullOrInvalid(date);
      if (dateIsInvalid) {
        setTextValue('');
      }
      needsFlush.current = false;
      setPrevValue(null);
      onChange(date, event.target.value);
    }
  };
  var handleChange = function handleChange(_ref2) {
    var target = _ref2.target;
    needsFlush.current = true;
    setTextValue(target.value);
  };
  return /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    type: "text",
    ref: ref,
    className: "rw-widget-input",
    value: textValue,
    disabled: disabled,
    readOnly: readOnly,
    onChange: handleChange,
    onBlur: handleBlur
  }));
});
DatePickerInput.displayName = 'DatePickerInput';
export default DatePickerInput;
function isValid(d) {
  return !isNaN(d.getTime());
}